// The three main users and their single-letter identifiers
export const SPECIAL_USERS: Record<string, string> = {
  '2bb88f42-cf99-452d-9062-1900683c8ecb': 'A', // Allen Cypher
  '1a617016-b826-467f-9e52-fa65f1b63766': 'M', // Max
  'fb45f412-c52b-40b7-88b5-7cb86dac3e77': 'D', // 文字化け
};

export const SPECIAL_USER_IDS = Object.keys(SPECIAL_USERS);
